import { Component, Vue } from 'vue-property-decorator';

@Component
export default class ArrayFaq extends Vue {
    tabs: any[] = [];

    active: number | null = null;

    mounted() {
        this.getData();
    }

    async getData() {
        const document = await this.$prismic.client.getSingle('array_faq');

        for (const question of document.data.question) {
            this.tabs.push(question);
        }

        this.$emit('load');
    }
}
